var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningCircle = function SvgWarningCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6565 2C7.1365 2 2.6665 6.48 2.6665 12C2.6665 17.52 7.1365 22 12.6565 22C18.1865 22 22.6665 17.52 22.6665 12C22.6665 6.48 18.1865 2 12.6565 2ZM12.6665 20C8.2465 20 4.6665 16.42 4.6665 12C4.6665 7.58 8.2465 4 12.6665 4C17.0865 4 20.6665 7.58 20.6665 12C20.6665 16.42 17.0865 20 12.6665 20ZM11.6665 15H13.6665V17H11.6665V15ZM11.6665 7H13.6665V13H11.6665V7Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning-circle.0cc4980c003dd306e77eee62c0891353.svg";